<template>
  <a-card
    class="project-list"
    :loading="loading"
    style="margin-bottom: 24px;min-height: 488px"
    :bordered="false"
    :title="$t('message.views.workbench.authorizationShop')"
    :body-style="{ padding: 0 }">
    <a slot="extra" href="/authorization/auth">{{$t('message.views.workbench.allShop')}}</a>
    <div>
      <a-card-grid class="project-card-grid" :key="i" v-for="(item, i) in shops">
        <a-card :bordered="false" :body-style="{ padding: 0 }">
          <a-card-meta>
            <div slot="title" class="card-title">
              <a-avatar slot="avatar" size="small" shape="square" :src="iconMap[item.platform]"/>
              <a>{{ item.shopName }}</a>
            </div>
            <div slot="description" class="card-description">
              {{ item.description }}
            </div>
          </a-card-meta>
          <div class="project-item">
            <a href="/#/">{{ item.sellerName }}</a>
            <span class="datetime">{{ item.site }}</span>
          </div>
        </a-card>
      </a-card-grid>
    </div>
  </a-card>
</template>

<script>
import request from '../../../utils/request'
import lazadaIcon from '../../../assets/country/LZD2.png'
import aeIcon from '../../../assets/country/AliExpress.png'
export default {
  name: 'AllAuthorizedShops',
  data () {
    return {
      shops: [],
      iconMap: {
        LAZADA: lazadaIcon,
        AEG: aeIcon
      },
      loading: true
    }
  },
  mounted () {
    this.getAuthorizedShops()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  methods: {
    getAuthorizedShops () {
      request({
        url: '/shipper/shopInfo',
        method: 'get'
      }).then(response => {
        console.log('getAuthorizedShops', response)
        this.shops = response.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.project-list {

  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .datetime {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.members {
  a {
    display: block;
    margin: 12px 0;
    line-height: 24px;
    height: 24px;

    .member {
      font-size: 14px;
      color: rgba(0, 0, 0, .65);
      line-height: 24px;
      max-width: 100px;
      vertical-align: top;
      margin-left: 12px;
      transition: all 0.3s;
      display: inline-block;
    }

    &:hover {
      span {
        color: #1890ff;
      }
    }
  }
}

.mobile {

  .project-list {

    .project-card-grid {
      width: 100%;
    }
  }

  .more-info {
    border: 0;
    padding-top: 16px;
    margin: 16px 0 16px;
  }

  .headerContent .title .welcome-text {
    display: none;
  }
}
</style>
<style scope>
.todo-container >>> .ant-card-body >>> .ant-table-wrapper >>> .ant-spin-container >>> ant-table-small{
  border:none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/AllAuthorizedShops.vue